/* import __COLOCATED_TEMPLATE__ from './password-input.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import clsx from 'clsx';

/** @type {string} */
const CLASS_NAME = 'GLM-fields-password-input';

/** @class */
class GlmFieldsPasswordInput extends Component {
  @tracked revealPassword = false;

  get classNames() {
    return clsx(
      CLASS_NAME,
      this.args.class,
    );
  }

  get className() {
    return CLASS_NAME;
  }

  get inputType() {
    return this.revealPassword
      ? 'text'
      : 'password';
  }

  /**
   *
   */
  @action
  toggleRevealed() {
    this.revealPassword = !this.revealPassword;
  }
}

export default GlmFieldsPasswordInput;
